import { render, staticRenderFns } from "./BackItemRequest.vue?vue&type=template&id=3c6f47ab&scoped=true&"
import script from "./BackItemRequest.vue?vue&type=script&lang=js&"
export * from "./BackItemRequest.vue?vue&type=script&lang=js&"
import style0 from "./BackItemRequest.vue?vue&type=style&index=0&id=3c6f47ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6f47ab",
  null
  
)

export default component.exports